export default __webpack_public_path__ + "static/media/pic5.f0bbec3f.jpg";